// languageConfig.js
import global_es from './resources/es/global.json';
import global_en from './resources/en/global.json';

import home_es from './resources/es/home.json'
import home_en from './resources/en/home.json'

import ideas_libertad_es from './resources/es/ideas-libertad.json'
import ideas_libertad_en from './resources/en/ideas-libertad.json'

import sobre_mi_es from './resources/es/sobre-mi.json'
import sobre_mi_en from './resources/en/sobre-mi.json'

import biblioteca_es from './resources/es/biblioteca.json'
import biblioteca_en from './resources/en/biblioteca.json'

import busqueda_es from './resources/es/busqueda.json'
import busqueda_en from './resources/en/busqueda.json'

import footer_es from './resources/es/footer.json';
import footer_en from './resources/en/footer.json';

import librBlanc_es from './resources/es/librBlanc.json';
import librBlanc_en from './resources/en/librBlanc.json';

import librVerd_es from './resources/es/librVerd.json';
import librVerd_en from './resources/en/librVerd.json';

import ideaCorta_es from './resources/es/ideaCorta.json';
import ideaCorta_en from './resources/en/ideaCorta.json';

import detail_blog_es from './resources/es/detail-blog.json';
import detail_blog_en from './resources/en/detail-blog.json';

import libroAzul_es from './resources/es/libro-azul.json';
import libroAzul_en from './resources/en/libro-azul.json';

import actividad_es from './resources/es/actividad.json';
import actividad_en from './resources/en/actividad.json';

import libroBitcoin_es from './resources/es/librBitcoin.json';
import libroBitcoin_en from './resources/en/librBitcoin.json';


const languageConfig = {
  es: {
    global: global_es,
    home: home_es,
    ideas_libertad: ideas_libertad_es,
    sobre_mi : sobre_mi_es,
    biblioteca : biblioteca_es,
    busqueda : busqueda_es,
    footer:footer_es,
    librBlanc:librBlanc_es,
    librVerd :librVerd_es,
    ideaCorta:ideaCorta_es,
    detail_blog: detail_blog_es,
    libroAzul: libroAzul_es,
    actividad: actividad_es,
    libroBitcoin: libroBitcoin_es
  },
  en: {
    global: global_en,
    home: home_en,
    ideas_libertad: ideas_libertad_en,
    sobre_mi : sobre_mi_en,
    biblioteca : biblioteca_en,
    busqueda : busqueda_en,
    footer: footer_en,
    librBlanc:librBlanc_en,
    librVerd :librVerd_en,
    ideaCorta:ideaCorta_en,
    detail_blog: detail_blog_en,
    libroAzul: libroAzul_en,
    actividad: actividad_en,
    libroBitcoin: libroBitcoin_en
  },
};

export default languageConfig;